import React from "react"

const CircleQuote = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
  >
    <g id="Group_6022" data-name="Group 6022" transform="translate(-457 -883)">
      <g
        id="Ellipse_4"
        data-name="Ellipse 4"
        transform="translate(457 883)"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
      >
        <circle cx="18" cy="18" r="18" stroke="none" />
        <circle cx="18" cy="18" r="16.5" fill="none" />
      </g>
      <g id="document" transform="translate(468 893)">
        <g id="Group_5870" data-name="Group 5870" transform="translate(0 0)">
          <g id="Group_5869" data-name="Group 5869">
            <path
              id="Path_16769"
              data-name="Path 16769"
              d="M64.323,2V18h8.824V13.169h5.176V2Zm3.719,3.339H74.6V6.477H68.042Zm0,2.53H74.6V9.007H68.042Zm0,3.668V10.4H74.6v1.138H68.042Z"
              transform="translate(-64.323 -2)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_5872"
          data-name="Group 5872"
          transform="translate(10.044 12.307)"
        >
          <g id="Group_5871" data-name="Group 5871">
            <path
              id="Path_16770"
              data-name="Path 16770"
              d="M339.35,403.673v3.693l3.956-3.693Z"
              transform="translate(-339.35 -403.673)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default CircleQuote
